import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "q-px-md" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Утвердить акт ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Отменить акт ")
const _hoisted_6 = { class: "q-pa-md flex" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Изменить сумму ")


import { useMainStore } from '@/store';
import { useContractsStore } from '@/store/contracts/contractsModule';
import TableComponent from '@/components/TableComponent/TableComponent.vue';
import { storeToRefs } from 'pinia';
import {
  Action, DragAndDropHandler, ITable, TableStructure,
} from '@/components/TableComponent/types';
import { actionHandler } from '@/actions/actionHandler';
import {
  computed, watch, ref,
} from 'vue';
import { IPayment, IContract } from '@/store/contracts/types';
import ActsStatusBar from '@/components/ActsStatusBar.vue';
import { BindingStatus } from '@/enums';

const actsStructure = {
  field_id: 'id',
  empty_state: 'Нет актов',
  search: 'json_name',
  expandable_rows: true,
  columns: [
    {
      name_column: 'act_status_text',
      colname: 'ID',
      visible: true,
      content_type: 'default',
    },
    {
      name_column: 'date_add',
      colname: 'ID',
      visible: true,
      content_type: 'default',
    },
    {
      name_column: 'list_pay',
      colname: 'Оплаты',
      visible: true,
      content_type: 'json',
      custom_component_name: 'PaymentList',
    },
    {
      name_column: 'payment_type',
      colname: 'ID',
      visible: true,
      content_type: 'default',
    },
    {
      name_column: 'sum_act',
      colname: 'ID',
      visible: true,
      content_type: 'default',
    },
    {
      name_column: 'who_add',
      colname: 'ID',
      visible: true,
      content_type: 'default',
    },
  ],
} as TableStructure;

const approveActAction: Action = {
  name: 'POST:act_approve',
  type: 'event',
  confirmation: true,
  confirmationText: 'Утвердить акт?',
  customParam: {
    nextAction: {
      type: 'custom',
      name: 'refreshActs',
    },
  },
};

const deleteActAction: Action = {
  name: 'POST:act_del',
  type: 'event',
  confirmation: true,
  confirmationText: 'Отменить акт?',
  customParam: {
    nextAction: {
      type: 'custom',
      name: 'refreshActs',
    },
  },
};

const __default__ = { name: 'ActsView', components: { TableComponent } };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  async setup(__props) {

let __temp: any, __restore: any

const contractsStore = useContractsStore();
const vertSplitterModel = ref(50);
const mainStore = useMainStore();
const actualSum = ref(0);

const {
  contracts,
  currentContractId,
  currentContract,
  acts,
  payments,
  selectedAct,
  selectedPayment,
  bindingStatus,
  idActPay,
} = storeToRefs(contractsStore);

const draggableActsTable = computed<ITable>(() => ({
  ...acts.value,
  structure: {
    ...acts.value.structure,
    draggable: {
      type: 'event',
      name: 'POST:act_merge',
      confirmation: true,
      confirmationText: 'Объединить акты?',
      customParam: {
        nextAction: {
          type: 'custom',
          name: 'refreshActs',
        },
        source_key: 'id_act_victim',
        recipient_key: 'id_act',
      },
    } as DragAndDropHandler,
  },
}));

const selectedContract = ref<IContract | null>(null);

const setContract = (contract: IContract) => {
  contractsStore.selectContract({ id_contract: contract.id_contract });
};

const sumEditRule = (val: number) => val <= calculatedSum.value || `Сумма привязки не может быть больше ${calculatedSum.value}р.`;

const loadActs = async () => {
  await contractsStore.loadActs();
};

const loadPayments = async () => {
  await contractsStore.loadPayments();
};

const loadContracts = async () => {
  await contractsStore.loadContracts();
};

const promises = [
  loadContracts(),
  loadActs(),
  loadPayments(),
];
;(
  ([__temp,__restore] = _withAsyncContext(() => Promise.allSettled(promises))),
  await __temp,
  __restore()
);

if (currentContract.value) {
  selectedContract.value = currentContract.value;
} else {
  selectedContract.value = contracts.value.data.find((item) => item.id_contract === 0) || null;
}

watch(currentContractId, async () => {
  await loadActs();
});

const reloadData = async () => {
  contractsStore.selectAct(null);
  contractsStore.selectPayment(null);
  contractsStore.setIdActPay(null);
  const promises = [
    loadActs(),
    loadPayments(),
  ];
  await Promise.all(promises);
};

const isMenuShown = ref(false);

const isPossibleToBind = computed<boolean>(
  () => Boolean(selectedPayment.value && selectedAct.value)
  || Boolean(selectedAct.value && idActPay.value),
);

const toggleMenu = () => {
  isMenuShown.value = !isMenuShown.value;
};

const selectPayment = (checkedPayments: number[]) => {
  if (checkedPayments.length) {
    contractsStore.selectPayment(checkedPayments[0]);
    return;
  }
  contractsStore.selectPayment(null);
};

const selectAct = (checkedActs: number[]) => {
  if (checkedActs.length) {
    contractsStore.selectAct(checkedActs[0]);
    return;
  }
  contractsStore.selectAct(null);
};

const calculatedSum = computed<number>(() => {
  if (!selectedPayment.value && !selectedAct.value) {
    return 0;
  }
  const actSum = selectedAct.value
    ? selectedAct.value.sum_act - selectedAct.value.sum_pay : 0;
  const paySum = selectedPayment.value
    ? selectedPayment.value.sum_pay - selectedPayment.value.sum_take_total : 0;
  if (!selectedPayment.value) {
    return actSum;
  }
  if (!selectedAct.value) {
    return paySum;
  }
  return Math.min(actSum, paySum);
});

watch(calculatedSum, (val) => {
  actualSum.value = val;
});

const approveAct = async () => {
  await actionHandler(approveActAction, { id_act: selectedAct.value?.id });
};

const deleteAct = async () => {
  await actionHandler(deleteActAction, { id_act: selectedAct.value?.id });
};

const processAct = async () => {
  if (bindingStatus.value === BindingStatus.BINDED) {
    const params = {
      id_act_pay: idActPay.value,
    };
    const result = await mainStore.dispatchEvent('POST:unbind_act_pay', params);
    if (result.data) {
      await reloadData();
    }
  } else {
    if (!actualSum.value) {
      return;
    }
    const params = {
      id_act: selectedAct.value?.id,
      id_pay: selectedPayment.value?.id_pay,
      summ_pay: actualSum.value,
    };
    const result = await mainStore.dispatchEvent('POST:bind_act_pay', params);
    if (result.data) {
      await reloadData();
    }
  }
};

const createAct = async () => {
  const action: Action = {
    name: 'POST:acts_add_automatically',
    type: 'event',
    confirmation: true,
    confirmationText: 'Подтвердите создание акта',
    customParam: {
      nextAction: {
        name: 'refreshActs',
        type: 'custom',
      },
    },
  };
  await actionHandler(action);
};

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_splitter = _resolveComponent("q-splitter")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_fab_action = _resolveComponent("q-fab-action")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_fab = _resolveComponent("q-fab")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_splitter, {
      style: {"height":"100%","width":"100%"},
      modelValue: vertSplitterModel.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((vertSplitterModel).value = $event))
    }, {
      before: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ActsStatusBar, {
            acts: _unref(acts).data
          }, null, 8, ["acts"]),
          (_unref(payments).data)
            ? (_openBlock(), _createBlock(TableComponent, {
                key: 0,
                tableId: "payments-table",
                table: _unref(payments),
                onSelection: selectPayment,
                onRefresh: _cache[0] || (_cache[0] = ($event: any) => (loadPayments()))
              }, null, 8, ["table"]))
            : _createCommentVNode("", true)
        ])
      ]),
      after: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_select, {
              class: "acts-status-bar__select",
              modelValue: selectedContract.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((selectedContract).value = $event)),
                setContract
              ],
              outlined: "",
              dense: "",
              "emit-value": "",
              "options-dense": "",
              label: "Договор",
              options: _unref(contracts).data,
              "option-label": "name_contract"
            }, {
              option: _withCtx((scope) => [
                _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.opt.name_contract), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Акты: " + _toDisplayString(scope.opt.n_a), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          (_unref(acts).data)
            ? (_openBlock(), _createBlock(TableComponent, {
                key: 0,
                tableId: "acts-table",
                table: _unref(draggableActsTable),
                selected: _unref(selectedAct) ? [_unref(selectedAct)?.id] : [],
                onSelection: selectAct,
                onRefresh: _cache[2] || (_cache[2] = ($event: any) => (loadActs()))
              }, null, 8, ["table", "selected"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_page_sticky, {
      position: "bottom-right",
      offset: [18, 18]
    }, {
      default: _withCtx(() => [
        (_unref(selectedAct))
          ? (_openBlock(), _createBlock(_component_q_fab, {
              key: 0,
              label: `${actualSum.value}р.`,
              "label-position": "right",
              "external-label": "",
              color: "accent",
              icon: "keyboard_arrow_left",
              direction: "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_fab_action, {
                  icon: "price_check",
                  color: "accent",
                  onClick: approveAct,
                  label: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_fab_action, {
                  icon: "delete",
                  color: "accent",
                  onClick: deleteAct
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_fab_action, {
                  disable: !_unref(isPossibleToBind),
                  color: "accent",
                  onClick: processAct,
                  icon: _unref(bindingStatus) === _unref(BindingStatus).NOT_BINDED ? 'link' : 'link_off'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(bindingStatus) === _unref(BindingStatus).NOT_BINDED
              ? `Связать ${actualSum.value}р.`
              : `Отвязать ${actualSum.value}р.`), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disable", "icon"]),
                _createVNode(_component_q_btn, {
                  disable: !_unref(isPossibleToBind),
                  round: "",
                  unelevated: "",
                  color: "accent",
                  icon: "edit"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_menu, {
                      modelValue: isMenuShown.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isMenuShown).value = $event)),
                      anchor: "top left",
                      self: "bottom left"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_q_input, {
                            modelValue: actualSum.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((actualSum).value = $event)),
                            dense: "",
                            rules: [sumEditRule]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_q_btn, {
                            color: "accent",
                            unelevated: "",
                            round: "",
                            flat: "",
                            icon: "done",
                            onClick: toggleMenu
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disable"])
              ]),
              _: 1
            }, 8, ["label"]))
          : (_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              fab: "",
              icon: "add",
              color: "accent",
              onClick: createAct
            }))
      ]),
      _: 1
    })
  ], 64))
}
}

})